module.exports = __webpack_public_path__ + "static/media/lightLocation.7c660e16.svg";